import { useEffect, useState } from "react";
import cover from "../../../assets/images/specialoffers.png";
import searchLocation from "../../../assets/images/website/icons/search-location.png";
import image from "../../../assets/images/developer_logo.png";
import SpecialCard from "components/Website/SpecialCard";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import SpecialOffersService from "services/Website/SpecialOffersService";
import AreasService from "services/Admin/AreasService";
import AsyncSelect from "react-select/async";
import CompoundService from "services/Admin/CompoundService";
import { useSelector } from "react-redux";
import HomeService from "services/Website/HomeService";
import { useTranslation } from "react-i18next";
import "./style.scss";

const SpecialOffers = () => {
	const [formData, setFormData] = useState({
		area: "",
		compound: "",
	});
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [areasOptions, setAreaOptions] = useState([]);
	const currency = useSelector((state) => state.Auth?.currency?.currency_code);
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);
	const specialOffersService = new SpecialOffersService();
	const areasService = new AreasService();
	const compoundsService = new CompoundService();
	const homeService = new HomeService();

	useEffect(() => {
		let param = {
			convert_price: 1,
		};
		if (!!formData?.area) param["area_ids"] = formData?.area?.value;
		if (!!formData?.compound) param["compound_ids"] = formData?.compound?.value;
		specialOffersService.getList(param).then((res) => {
			if (res?.status) {
				setData(res?.data);
				!!res?.data?.length ? setHasData(1) : setHasData(0);
			}
		});
	}, [formData, currency]);

	useEffect(() => {
		areasService.getAreaDropDown().then((res) => {
			const data = res.data?.map((item) => {
				return {
					name: item.name,
					label: item.name[`${AuthData.lang}`]
						? item.name[`${AuthData.lang}`]
						: item.name.en,
					value: item.id,
				};
			});
			setAreaOptions(data);
		});
	}, []);

	const promiseOptions = (inputValue) => {
		if (inputValue?.length <= 1) {
			document.getElementById("specialDiv")?.classList.add("specialDiv");
			setFormData({ ...formData, compound: "" });
			return;
		}

		return new Promise((resolve, reject) => {
			homeService
				.getDeveloperCompoundData(inputValue)
				.then((res) => {
					if (res?.status) {
						const compounds = res?.data?.compounds?.map((comp) => {
							return {
								...comp,
								type: "compound",
								label: comp?.name?.en, // Set label to the English name
								value: comp?.id, // Set value to the compound ID
							};
						});
						document
							.getElementById("specialDiv")
							?.classList.remove("specialDiv");

						resolve([
							{
								options: compounds,
							},
						]);
					} else {
						reject(new Error("Failed to fetch compounds"));
					}
				})
				.catch((error) => {
					reject(error); // Handle error appropriately
				});
		});
	};

	return (
		<div className="special-offers">
			<div className="container">
				<div className="d-md-flex align-items-center mb-5 justify-content-between">
					<h2
						className="title pb-3 pb-md-0"
						dangerouslySetInnerHTML={{
							__html: t("Special Deals"),
						}}></h2>
					<p className="choose">Choose Your Units Now</p>
				</div>

				<p className="mb-3 available-offers text-primary">
					Available Offers{" "}
					<span style={{ fontWeight: "400" }}>
						(<span className="mx-1">{data?.length}</span>)
					</span>
				</p>

				<div className="select-area-compound d-md-flex gap-2">
					<div>
						<AsyncSelect
							placeholder="Search Compound"
							// cacheOptions
							id="specialDiv"
							className="specialDiv select"
							value={formData?.compound}
							loadOptions={promiseOptions}
							onChange={(data) => setFormData({ ...formData, compound: data })}
						/>
					</div>
					<div>
						<Select
							options={areasOptions}
							name="area"
							placeholder="Select Area"
							className="select"
							value={formData?.area}
							onChange={(data) => setFormData({ ...formData, area: data })}
						/>
					</div>
				</div>

				<hr />

				<div className="px-lg-5 offers-div">
					<Row>
						{hasData === 0 && (
							<div style={{ minHeight: "10rem" }}>
								<h2 className="text-center text-primary">
									There's no Special Offers
								</h2>
							</div>
						)}
						{hasData === 1 &&
							data?.map((offer, index) => {
								return (
									<Col md={6} xl={4}>
										<SpecialCard data={offer} key={index} />
									</Col>
								);
							})}
					</Row>
				</div>
			</div>
		</div>
	);
};
export default SpecialOffers;
